<div *ngIf="publishedDate$ | async as publishedDate">{{ publishedDate | date : 'yyyy-MM-dd' }}</div>
